export default function Footer() {
  return (
    <footer className="max-w-5xl mx-auto px-6 md:px-12 py-7 border-t border-[var(--border)] flex flex-col md:flex-row justify-between items-center gap-2 font-mono text-xs text-[var(--text-dim)]">
      <span>© 2026 Vaishnavi Kadam</span>
      <span>Built with <span className="text-green-500">♥</span> and a lot of cold coffee hehe</span>
    </footer>
  );
}